import React from 'react';

class LoadingIndicator extends React.Component {
  render(){
    return (
      <li className="list-group-item">
        <div className="loading-container">
          <div className="loading-spinner">
          </div>
          <div className="loading-text">
            {this.props.text}
          </div>
        </div>
      </li>
    )
  }
}

export default LoadingIndicator;